export function sortSparepartRecommendation(spareparts) {
  const newSpareparts = spareparts.sort(
    (a, b) => Number(b.is_recommended) - Number(a.is_recommended)
  )
  return newSpareparts
}
